import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from "@/store/features/baseRtkQuery";

export interface WidgetConfigResponse {
    id: string;
    widgetName: string;
    displayName: string;
    title?: string;
    width: number;
    height: number;
    config: any;
    isActive?: boolean;
    createdAt: string;
    updatedAt?: string;
    message?: string;
}

export interface UpdateWidgetRequest {
    widgetName?: string;
    displayName?: string;
    title?: string | null;
    width?: number;
    height?: number;
    config?: any;
    isActive?: boolean;
}

export interface WidgetErrorResponse {
    error: string;
}

export const iframableWidgetApiSlice = createApi({
    reducerPath: 'iframableWidget',
    baseQuery: baseQueryWithReAuth,
    tagTypes: ['WidgetConfig'],
    endpoints: (builder) => ({
        getWidgetConfig: builder.query<WidgetConfigResponse, string>({
            query: (widgetId) => ({
                url: `IframableWidget/${widgetId}`,
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
            }),
            providesTags: (result, error, widgetId) => [
                { type: 'WidgetConfig', id: widgetId }
            ],
            transformResponse: (response: any) => {
                if (response.error) {
                    throw new Error(response.error);
                }
                return response;
            },
        }),
        updateWidgetConfig: builder.mutation<WidgetConfigResponse, { widgetId: string; data: UpdateWidgetRequest }>({
            query: ({ widgetId, data }) => ({
                url: `IframableWidget/${widgetId}`,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: data,
            }),
            invalidatesTags: (result, error, { widgetId }) => [
                { type: 'WidgetConfig', id: widgetId }
            ],
            transformResponse: (response: any) => {
                if (response.error) {
                    throw new Error(response.error);
                }
                return response;
            },
        }),
    }),
});

const {
    useGetWidgetConfigQuery,
    useUpdateWidgetConfigMutation,
} = iframableWidgetApiSlice;

export const iframableWidgetApiActions = {
    useGetWidgetConfigQuery,
    useUpdateWidgetConfigMutation,
};